import { Outlet } from 'react-router-dom';
import Navbar from "../Navbar";

const GlobalLayout = () => {
    return (
        <div>
            <Navbar />
            <main className={'main'}>
                <Outlet />
            </main>
            <footer>
                {/*<p>© 2024 My App</p> // footer*/}
            </footer>
        </div>
    );
};

export default GlobalLayout;
